import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "custom-switch"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-switch" }),
  /*#__PURE__*/_createTextVNode(" Custom Switch ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".form-check-custom"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("code", null, ".form-check-solid"),
  /*#__PURE__*/_createTextVNode(" class with "),
  /*#__PURE__*/_createVNode("code", null, ".form-switch"),
  /*#__PURE__*/_createTextVNode(" to set custom layout with solid background style for a form switch: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><div class=\"form-check form-switch form-check-custom form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexSwitchDefault\"><label class=\"form-check-label\" for=\"flexSwitchDefault\"> Default switch </label></div></div><div class=\"mb-10\"><div class=\"form-check form-switch form-check-custom form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexSwitchChecked\" checked=\"checked\"><label class=\"form-check-label\" for=\"flexSwitchChecked\"> Checked switch </label></div></div>", 2)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-check form-switch form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      value: "",
      id: "flexSwitchDisabled",
      Disabled: "",
      checked: "checked"
    }),
    /*#__PURE__*/_createVNode("label", {
      class: "form-check-label",
      for: "flexSwitchDisabled"
    }, " Disabled switch ")
  ])
], -1)
const _hoisted_9 = { class: "py-0" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="mb-10">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Default checkbox
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked="checked"
                />
                <label class="form-check-label" for="flexCheckChecked">
                  Checked checkbox
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  disabled
                  id="flexCheckDisabled"
                />
                <label class="form-check-label" for="flexCheckDisabled">
                  Disabled checkbox
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexRadioDefault"
                />
                <label class="form-check-label" for="flexRadioDefault">
                  Default radio
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexRadioChecked"
                  checked="checked"
                />
                <label class="form-check-label" for="flexRadioChecked">
                  Checked radio
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  disabled
                  id="flexRadioDisabled"
                />
                <label class="form-check-label" for="flexRadioDisabled">
                  Disabled radio
                </label>
              </div>
            </div>
            `))
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "pt-15 pb-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("a", {
    class: "fw-bold",
    href: "#",
    target: "_blank"
  }, "Custom Size Classes"),
  /*#__PURE__*/_createTextVNode("  for switches to set custom sizes: ")
], -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = { class: "rounded border p-10" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10 d-flex\"><div class=\"form-check form-switch form-check-custom form-check-solid me-10\"><input class=\"form-check-input h-20px w-30px\" type=\"checkbox\" value=\"\" id=\"flexSwitch20x30\"><label class=\"form-check-label\" for=\"flexSwitch20x30\"> 20px x 30px </label></div><div class=\"form-check form-switch form-check-custom form-check-solid me-10\"><input class=\"form-check-input h-30px w-50px\" type=\"checkbox\" value=\"\" id=\"flexSwitch30x50\"><label class=\"form-check-label\" for=\"flexSwitch30x50\"> 30px X 50px </label></div><div class=\"form-check form-switch form-check-custom form-check-solid me-10\"><input class=\"form-check-input h-40px w-60px\" type=\"checkbox\" value=\"\" id=\"flexSwitch40x60\"><label class=\"form-check-label\" for=\"flexSwitch40x60\"> 40px X 60px </label></div></div>", 1)
const _hoisted_15 = { class: "py-0" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="mb-10">
              <div
                class="form-check form-check-custom form-check-solid form-check-lg"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckboxLg"
                />
                <label class="form-check-label" for="flexCheckboxLg">
                  Large checkbox
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div
                class="form-check form-check-custom form-check-solid form-check-lg"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckboxSm"
                />
                <label class="form-check-label" for="flexCheckboxSm">
                  Large radio
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div
                class="form-check form-check-custom form-check-solid form-check-sm"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexRadioLg"
                />
                <label class="form-check-label" for="flexRadioLg">
                  Small checkbox
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div
                class="form-check form-check-custom form-check-solid form-check-sm"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexRadioSm"
                />
                <label class="form-check-label" for="flexRadioSm">
                  Small radio
                </label>
              </div>
            </div>
            `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_CodeHighlighter, {
            fieldHeight: 400,
            lang: "html"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_11,
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_CodeHighlighter, {
            fieldHeight: 400,
            lang: "html"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}